const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, Record<string, Record<string, Record<string, unknown>>>> = {};

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function processGroup(group: unknown): Record<string, unknown> | null {
  if (!isPlainObject(group)) {
    return null;
  }

  const result: Record<string, unknown> = {};
  let hasValues = false;

  Object.keys(group).forEach((subKey) => {
    const value = group[subKey];
    if (typeof value === 'string') {
      result[subKey] = value;
      hasValues = true;
    } else if (isPlainObject(value)) {
      const nested = processGroup(value);
      if (nested && Object.keys(nested).length > 0) {
        result[subKey] = nested;
        hasValues = true;
      }
    }
  });

  return hasValues ? result : null;
}

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (!match) return;

  const [, lang, namespace] = match;
  const mod = modules[path] as Record<string, unknown>;

  if (!messages[lang]) {
    messages[lang] = {};
  }
  if (!messages[lang][namespace]) {
    messages[lang][namespace] = {};
  }

  Object.keys(mod).forEach((groupKey) => {
    if (groupKey === 'default') return;
    const group = mod[groupKey];
    const nested = processGroup(group);
    if (nested && Object.keys(nested).length > 0) {
      messages[lang][namespace][groupKey] = nested;
    }
  });
});

export default messages;